module.exports = __webpack_public_path__ + "img/Saly.b731f031.png";